import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firebaseconfig';
import { collection, addDoc, getDocs, deleteDoc, doc, updateDoc } from 'firebase/firestore'; // Removed serverTimestamp
import { MapPin, Trash2, Globe, ListOrdered, Edit3, Check, X } from 'lucide-react';
import AdminSidebar from './adminsidebar';

const AdminAddState = () => {
  const [stateName, setStateName] = useState('');
  const [statesList, setStatesList] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [editId, setEditId] = useState(null); 
  const [editValue, setEditValue] = useState(''); 

  const fetchStates = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, "states"));
      const stateData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setStatesList(stateData);
    } catch (error) {
      console.error("Error fetching states:", error);
    }
    setLoading(false);
  };

  useEffect(() => { fetchStates(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stateName.trim()) return;
    try {
      // Removed serverTimestamp from the object below
      await addDoc(collection(db, "states"), {
        name: stateName.trim()
      });
      setStateName('');
      fetchStates(); 
    } catch (error) { console.error(error); }
  };

  const startEdit = (state) => {
    setEditId(state.id);
    setEditValue(state.name);
  };

  const cancelEdit = () => {
    setEditId(null);
    setEditValue('');
  };

  const handleUpdate = async (id) => {
    if (!editValue.trim()) return;
    try {
      const stateRef = doc(db, "states", id);
      await updateDoc(stateRef, { name: editValue.trim() });
      setEditId(null);
      fetchStates();
      alert("Updated successfully!");
    } catch (error) {
      console.error("Error updating:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure?")) {
      await deleteDoc(doc(db, "states", id));
      fetchStates();
    }
  };

  return (

    
        <div className="container-fluid">
         <div className="">
      <div className="row g-4">
        
        <div className="col-lg-4">
          <div className="card border-0 shadow-sm rounded-4 p-4">
            <h4 className="fw-bold mb-4 text-primary d-flex align-items-center">
              <MapPin className="me-2" size={22} /> New State
            </h4>
            <form onSubmit={handleSubmit}>
              <input 
                type="text" 
                className="form-control bg-light border-0 mb-3" 
                placeholder="e.g. Gujarat"
                value={stateName}
                onChange={(e) => setStateName(e.target.value)}
                required 
              />
              <button type="submit" className="btn btn-primary w-100 fw-bold shadow-sm">SAVE STATE</button>
            </form>
          </div>
        </div>

        <div className="col-lg-8">
          <div className="card border-0 shadow-sm rounded-4 p-4">
            <h4 className="fw-bold mb-4 d-flex align-items-center">
              <ListOrdered className="me-2 text-primary" size={22} /> State List
            </h4>
            
            <div className="table-responsive">
              <table className="table align-middle">
                <thead className="table-light">
                  <tr>
                    <th>State Name</th>
                    <th className="text-end pe-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="2" className="text-center py-4 text-muted">Loading states...</td></tr>
                  ) : (
                    statesList.map((st) => (
                      <tr key={st.id}>
                        <td>
                          {editId === st.id ? (
                            <input 
                              type="text" 
                              className="form-control form-control-sm border-primary" 
                              value={editValue} 
                              onChange={(e) => setEditValue(e.target.value)}
                              autoFocus
                            />
                          ) : (
                            <span className="fw-bold">{st.name}</span>
                          )}
                        </td>
                        <td className="text-end">
                          {editId === st.id ? (
                            <>
                              <button className="btn btn-sm btn-success me-2 shadow-sm" onClick={() => handleUpdate(st.id)}><Check size={16}/></button>
                              <button className="btn btn-sm btn-secondary shadow-sm" onClick={cancelEdit}><X size={16}/></button>
                            </>
                          ) : (
                            <>
                              <button className="btn btn-sm text-primary me-2" onClick={() => startEdit(st)}><Edit3 size={16}/></button>
                              <button className="btn btn-sm text-danger" onClick={() => handleDelete(st.id)}><Trash2 size={16}/></button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
        </div>
      
    
  );
};

export default AdminAddState;